import loadingSelector from './loading_selector'

export default {
	loadingSelector,
}
